import React, { createContext, useContext, useState } from 'react';

const ExamModeContext = createContext();

export const useExamMode = () => {
  const context = useContext(ExamModeContext);
  if (!context) {
    throw new Error('useExamMode must be used within ExamModeProvider');
  }
  return context;
};

export const ExamModeProvider = ({ children }) => {
  const [isExamMode, setIsExamMode] = useState(false);
  const [step, setStep] = useState(0);

  return (
    <ExamModeContext.Provider value={{ isExamMode, setIsExamMode, step, setStep }}>
      {children}
    </ExamModeContext.Provider>
  );
};
